import { MaterialIcon } from "@website/icons/material";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import { ReservePoliciesPropertiesTypes } from "@website/widget/reserve-policies/reserve-policies.types";
import { toStringTime } from "@website/widget/reserve-policies/reserve-policies.utils";
import { useRouter } from "next/router";
import { memo, useMemo } from "react";

const Component = (properties: ReservePoliciesPropertiesTypes) => {
  const {
    checkinTime,
    checkoutTime,
    hotelType,
    rulesAllowed = [],
    rulesDisAllowed = []
  } = properties;
  const router = useRouter();
  const isVilla = process.env.NEXT_PUBLIC_APP_NAME === "villa";
  const checkinString = useMemo(() => {
    const unlimitedTime = "infinite";
    const unlimitedTimeText = "نامحدود";
    const splitCheckinTime = checkinTime
      ?.split("-")
      ?.map((c) =>
        c === unlimitedTime ? unlimitedTimeText : isVilla ? c : toStringTime(c)
      );

    return numberConvert((splitCheckinTime ?? []).join(" - "), {
      locale: router.locale
    });
  }, [checkinTime, router.locale]);

  if (!checkinTime || !checkoutTime) return null;
  return (
    <div className="flex w-full flex-col gap-4" id="hotel_policies">
      <h2 className="text-subtitle-1 md:text-headline-6">
        {`قوانین ${hotelType}`}
      </h2>
      <div className="flex flex-row gap-4">
        <div className="border-outline-thin flex w-max min-w-[200px] flex-col gap-2 rounded-[8px] border p-2 md:flex-row">
          <div className="w-[24px] text-center">
            <MaterialIcon
              className="text-on-surface-medium-emphasis scale-150"
              name="login"
            />
          </div>
          <div className="flex flex-col gap-1 md:flex-auto">
            <div className="text-caption text-on-surface-medium-emphasis">
              ساعت ورود
            </div>
            <div className="text-body-1 text-on-surface-high-emphasis">
              {checkinString}
            </div>
          </div>
        </div>
        <div className="border-outline-thin flex w-[200px] flex-col gap-2 rounded-[8px] border p-2 md:flex-row">
          <div className="w-[24px] text-center">
            <MaterialIcon
              className="text-on-surface-medium-emphasis scale-150"
              name="logout"
            />
          </div>
          <div className="flex flex-col gap-1 md:flex-auto">
            <div className="text-caption text-on-surface-medium-emphasis">
              ساعت خروج
            </div>
            <div className="text-body-1 text-on-surface-high-emphasis">
              {numberConvert(
                isVilla ? checkoutTime : toStringTime(checkoutTime),
                {
                  locale: router.locale
                }
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2">
        {rulesAllowed?.length > 0 && (
          <div>
            {rulesAllowed.map((rule) => (
              <div
                className="flex items-center"
                key={`${rule?.title}_${rule?.id}`}
              >
                <MaterialIcon
                  className="text-success text-xl"
                  name="check_circle"
                  variant="outlined"
                />

                <p className="text-on-surface-high-emphasis text-body-2 mr-1">
                  {rule?.title}
                </p>
              </div>
            ))}
          </div>
        )}
        {rulesDisAllowed?.length > 0 && (
          <div>
            {rulesDisAllowed.map((rule) => (
              <div
                className="flex items-center"
                key={`${rule?.title}_${rule?.id}`}
              >
                <MaterialIcon
                  className="text-on-surface-medium-emphasis text-xl"
                  name="cancel"
                  variant="outlined"
                />
                <p className="text-on-surface-high-emphasis text-body-2 mr-1">
                  {rule?.title}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
export const ReservePolicies = memo(Component, deepCompare);
